
































import { Prop, Component, Vue } from 'vue-property-decorator';
import { BillFields, BillStatusEnum } from '@/types/graphql/schemaTypes';
import { Button } from 'element-ui';
import get from 'lodash/get';
import BillComplete from '@/components/modals/bill/BillComplete.vue';

// gql
import billPublishMutation from '@/graphql/mutations/BillPublish.gql';

@Component({
  components: {
    'complete-modal': BillComplete,
    'el-button': Button
  }
})
export default class Publish extends Vue {
  @Prop() private bill!: BillFields;

  private billingIncomplte = false;
  private isLoading = false;
  private isModalOpen = false;

  private setModalOpen(value: boolean) {
    this.isModalOpen = value;
  }

  private async publishBill(billingIncomplete) {
    this.isLoading = true;

    try {
      const response = await this.$apollo.mutate({
        mutation: billPublishMutation,
        variables: {
          billArgs: { id: this.bill.id },
          billingComplete: !billingIncomplete
        }
      });

      if (response) {
        this.$store.dispatch('Alert/addAlert', {
          type: 'success',
          message: this.$t('bill.sent.success'),
          time: 2000
        });

        this.setModalOpen(false);
        this.$emit('refresh');
      }
    } catch (error) {
      this.$store.dispatch('Alert/addAlert', {
        type: 'error',
        message: this.$t('error.push'),
        time: 2000
      });
    } finally {
      this.isLoading = false;
    }
  }

  get isValid() {
    return this.bill.status !== BillStatusEnum.paid && !!this.bill.dueDate;
  }
}
